// src/js/reducers/index.js
import * as types from "../constants/action-types";
import Sorter from '../utils/sorter';


export default function workTypeReducer(state = [], action) {
    switch (action.type) {
        
        case types.LOGOUT:
            return []
        case types.LOAD_WORK_TYPE_SUCCESS:

            return  Sorter.sort(action.workTypes, 'type');
        
        default:
            return state;
    };
};


